import BaseComponent from '@js/BaseComponent'

/**
 * Manages PasswordProtectForm component instances.
 *
 * @extends BaseComponent
 */
class PasswordProtectForm extends BaseComponent {
    constructor(element) {
        super(element)
    }
}

PasswordProtectForm.create('.password-protect')
